module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921032649_T.1ccf467d.jpg";